import {createApp} from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import MarqueeText from "vue-marquee-text-component";
import ScriptX from "vue-scriptx";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "@vueform/multiselect/themes/default.css";
import Notifications from "@kyvg/vue3-notification";
import Hotjar from "vue-hotjar";
import Ads from "vue-google-adsense";
//import {createMetaManager, plugin as vueMetaPlugin} from "vue-meta";
import Vue3ConfirmDialog from 'vue3-confirm-dialog';


import {MX_INIT} from "./util/Mixpanel";
import store from "./store";
import axios from "axios";
//import formbricks from "@/util/formbricks";

/*date picker*/
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import 'vue3-confirm-dialog/style';

const app = createApp(App);

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

import VueTour from "v3-tour";

require("v3-tour/dist/vue-tour.css");

//Require
require("@/store/subscriber");

//Use
app.use(ScriptX);
app.use(Ads.Adsense);
app.use(Vuex);
app.use(BootstrapVueNext);
//app.use(IconsPlugin);
app.use(Notifications);
app.use(VueTour);
//app.use(createMetaManager());
//app.use(vueMetaPlugin);
app.use(Hotjar, {
    id: process.env.VUE_APP_HOTJAR_SITE_ID,
    isProduction: process.env.VUE_APP_HOTJAR_IS_PRODUCTION === "true",
});
app.component("VueDatePicker", VueDatePicker);
app.use(Vue3ConfirmDialog);

//components
app.component("marquee-text", MarqueeText);
app.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)

app.config.productionTip = false;
MX_INIT();

app.use(router);
app.use(store);
/*router.afterEach(() => {
    if (typeof formbricks !== "undefined") {
        formbricks.registerRouteChange();
    }
});*/

import {createLogto} from "@logto/vue";
import {emitter} from "@/util/emiter";
import './registerServiceWorker'

const config = {
    endpoint: process.env.VUE_APP_LOGTO_BASE_URL,
    appId: process.env.VUE_APP_LOGTO_APP_ID,
};
app.use(createLogto, config);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            emitter.emit("signOut");
            return;
        }
        throw error;
    }
);

store.dispatch("setUUID", localStorage.getItem("uuid")).then(() => {
    store
        .dispatch(
            "setTOKEN",
            localStorage.getItem(`logto:${process.env.VUE_APP_LOGTO_APP_ID}:idToken`)
        )
        .then(() => {
            app.mount("#app");
        });
});
